<template>
  <div class="home">
    <Aheader :realIndex="0"></Aheader>
    <div class="banner">
      <div class="banner-mes">
        <p class="title">FWAlgaeDB</p>
        <p class="detail">
          Fresh<span>W</span>ater Algae Data<span>B</span>ase - Helps
          researchers retrieve and <span>study</span>
          freshwater algae quickly and accurately.
        </p>
        <div class="search">
          <input
            v-model.trim="input"
            @keyup.enter="toSearchJump()"
            placeholder="Please enter"
            type="text"
          />
          <img
            @click="toSearchJump()"
            src="../../assets/img/home-search.png"
            alt="search"
          />
          <div class="search-result" v-if="input.length !== 0">
            <p
              v-if="searchResult.length === 0"
              style="color:#999;cursor: default;"
            >
              Search no results
            </p>
            <p
              class="search-result-mes"
              v-for="item in searchResult"
              :key="item.index"
              @click="toSearchJump(item)"
            >
              <span v-if="item.type !== 'Species'">{{ item.name }}</span>
              <span v-else>
                <span style="font-style: italic;">{{ item.italicName }}</span
                ><span>{{ item.notItalicName }}</span>
              </span>
              <span class="result-type">{{ item.type }}</span>
            </p>
          </div>
        </div>
        <div class="recommend">
          <span>Recommend:</span>
          <span v-for="(item, index) in recommend" :key="index">
            <span v-if="index != 0">,</span>

            <span class="item" @click="toDetail(item)">
              <span style="font-style: italic;">{{ item.italicName }}</span
              ><span>{{ item.notItalicName }}</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <p class="headline">Phylogenetic Tree</p>
    <div class="evolutionary">
      <img src="../../assets/img/home-tree.png" alt="Evolutionary tree" />
      <div class="shade"></div>
    </div>
    <div class="introduction-box">
      <p class="headline">Database Introduction</p>
      <div class="introduction">
        <img
          src="../../assets/img/home-introduction.png"
          alt="data introduction"
        />
        <div class="detail">
          <p class="long-text">
            FWAlgaeDB is a user-friendly database aiming to provide
            comprehensive information on freshwater algae. It incorporates
            taxonomy, genome sequence, and annotation information for more than
            200 freshwater algae species with access for free download.
            FWAlgaeDB integrates the BLAST analysis tool to facilitate
            similarity search for your sequence of interest. Keyword search and
            download sections enable rapid retrieval and help researchers
            quickly obtain information on focus species.
          </p>
          <p>
            This database serves as an open-access and sustained platform
            providing genomic and molecular tools that can conveniently study
            freshwater algae for biological discovery, bioenergy, and ecological
            water protection.
          </p>
        </div>
      </div>
    </div>
    <div class="bot-map">
      <p>This is a freshwater algae data platform</p>
    </div>
    <el-backtop
      target=".home"
      :visibility-height="100"
      :right="150"
      :bottom="150"
    >
      <i class="el-icon-caret-top"></i>
    </el-backtop>
    <Afooter></Afooter>
  </div>
</template>

<script>
import http from '../../utils/http'
import api from '../../utils/api'
import { Message } from 'element-ui'
import Aheader from '../../components/aheader.vue'
import Afooter from '../../components/afooter.vue'
export default {
  name: 'Home',
  components: {
    Aheader,
    Afooter
  },
  created () {
    this.$store.commit('toTop')
    this.recommend.forEach(ele => {
      let obj = this.$utils.getItalic(ele.name)
      ele.italicName = obj.italicName
      ele.notItalicName = obj.notItalicName
    })
  },
  data () {
    return {
      input: '',
      recommend: [
        { name: 'Volvox reticuliferus', id: '1' },
        { name: 'Chlorogloea purpurea', id: '2' },
        { name: 'Cyclotella cryptica CCMP332', id: '3' },
        { name: 'Raphidocelis subcapitata', id: '4' }
      ],
      searchResult: []
    }
  },
  methods: {
    // 获取模糊搜索的数据
    fuzzyList (val) {
      if (val.length !== 0) {
        api
          .fuzzyList(val)
          .then(res => {
            if (res.data.code === 200) {
              this.searchResult = res.data.data
              this.searchResult.forEach(ele => {
                if (ele.type === 'Species') {
                  let obj = this.$utils.getItalic(ele.name)
                  ele.italicName = obj.italicName
                  ele.notItalicName = obj.notItalicName
                }
              })
            } else {
              Message.error(`${res.data.msg}`)
            }
          })
          .catch(req => {
            Message.error(`${req}`)
          })
      }
    },
    // 搜索结果跳转
    toSearchJump (val = null) {
      if (this.input.length !== 0) {
        let name = ''
        if (val) {
          name = val.name
          this.input = val.name
        } else {
          name = this.input
        }
        http.get(
          `/speciesList?name=${name}&currentPage=1&pageSize=6`,
          {},
          res => {
            if (res.code === 200) {
              if (res.data.total === 0) {
                // message只出现一次
                if (
                  document.getElementsByClassName('el-message').length === 0
                ) {
                  Message.error('Search no results')
                }
              } else if (res.data.total === 1) {
                if (res.data.species[0].isOpen === 1) {
                  this.$router.push(
                    `/home/detail?input=${this.input}&id=${res.data.species[0].id}`
                  )
                } else {
                  Message.error('The species is not public')
                }
              } else {
                this.$router.push(`/home/search?input=${this.input}`)
              }
            } else {
              Message.error(`${res.msg}`)
            }
          }
        )
      }
    },
    toDetail (item) {
      http.get(`/speciesSelectByKey?key=${item.name}`, {}, res => {
        if (res.code === 200) {
          this.$router.push(`/home/detail?id=${res.data.species.speciesId}`)
        } else {
          Message.error(`${res.msg}`)
        }
      })
    }
  },
  watch: {
    input (newAl, oldAl) {
      if (newAl.length !== 0) {
        this.fuzzyList(newAl)
      } else {
        this.searchResult = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  min-width: vw(1200);
  .el-icon-caret-top {
    color: $theme_color;
  }

  .banner {
    margin-top: vw(81);
    margin-bottom: vw(96);
    padding-top: vw(130);
    box-sizing: border-box;
    height: vw(772);
    background-image: url('../../assets/img/home-banner.png');
    background-size: 100% 100%;
    font-size: vw(22);
    color: #ffffff;

    .banner-mes {
      width: vw(1200);
      margin: 0 auto;

      .title {
        font-size: vw(48);
        font-weight: bold;
        position: relative;
        margin-bottom: vw(53);

        &::after {
          display: block;
          content: '';
          position: absolute;
          bottom: -12px;
          left: 0;
          width: vw(286);
          height: 4px;
          background: #fff;
        }
      }

      .detail {
        width: vw(990);
        line-height: 1.5;
        margin-bottom: vw(40);
      }

      .search {
        position: relative;
        width: vw(964);
        height: vw(74);
        margin-bottom: vw(22);
        input {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: #ffffff;
          border-radius: 8px;
          color: #999999;
          font-size: vw(20);
          padding-left: vw(19);
          border: 1px solid #fff;
          box-sizing: border-box;

          &:hover,
          &:focus {
            border-color: $theme_color;
          }
        }

        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: vw(30);
          cursor: pointer;
        }
        .search-result {
          position: absolute;
          top: 100%;
          left: 0;
          z-index: 1;
          width: 100%;
          max-height: 300px;
          overflow: auto;
          color: #333;
          background-color: #fff;
          border: 1px solid #999;
          border-radius: 10px;
          box-sizing: border-box;
          cursor: pointer;

          p {
            display: flex;
            justify-content: space-between;
            padding: vw(10) vw(20);
            font-size: vw(18);
          }

          .search-result-mes {
            .result-type {
              margin-left: 20px;
              font-size: vw(15);
              color: #999;
            }

            &:hover {
              color: $theme_color;
              background-color: rgba(151, 151, 147, 0.1);
            }
          }
        }
      }

      .recommend {
        width: vw(1200);
        height: vw(29);
        overflow: hidden;
        span {
          display: inline-block;
        }
        .item {
          color: #fff;
          cursor: pointer;
          &:hover {
            color: $theme_color;
          }
        }
      }
    }
  }

  .headline {
    font-size: vw(22);
    color: #333333;
    position: relative;
    text-align: center;
    letter-spacing: 2px;
    margin-bottom: vw(61);
    font-weight: bold;

    &::after {
      display: block;
      content: '';
      position: absolute;
      bottom: -13px;
      left: 50%;
      transform: translateX(-50%);
      background: $theme_color;
      width: 29px;
      height: 2px;
    }
  }

  .evolutionary {
    position: relative;
    width: vw(1200);
    margin: 0 auto vw(160);
    img {
      width: vw(1200);
    }
    .shade {
      position: absolute;
      top: 0;
      right: 0;
      width: vw(1200);
      height: vw(790);
      background: #fff;
      opacity: 0.95;
      animation: move 10s linear infinite;
    }
  }
  .introduction-box {
    padding: 100px 0;
    background-color: rgba(196, 203, 221, 0.1);
  }
  .introduction {
    width: vw(1200);
    margin: 0 auto;
    display: flex;

    img {
      width: vw(400);
      margin-right: vw(100);
    }

    .detail {
      margin-top: vw(80);
      font-size: vw(18);
      color: #333;

      p {
        &:first-child {
          margin-bottom: vw(25);
        }
        &:last-child {
          margin-top: vw(25);
        }
      }
    }
  }

  .bot-map {
    background-image: url('../../assets/img/home-bot-banner.png');
    height: vw(238);
    background-size: 100% 100%;
    color: #ffffff;
    font-size: vw(52);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@mixin keyframes($animationName) {
  @-webkit-keyframes #{$animationName} {
    @content;
  }
  @-moz-keyframes #{$animationName} {
    @content;
  }
  @-o-keyframes #{$animationName} {
    @content;
  }
  @keyframes #{$animationName} {
    @content;
  }
}

@include keyframes(move) {
  0% {
    width: vw(1200);
  }
  100% {
    width: vw(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue